/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

//calendar --------------------------------------------
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
// -----------------------------------------------

import {
  getData,
  uploadSingleFile,
  uploadMultipleFile,
  postData,
  putData,
  deleteData,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";

import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import AvailibilityPublicHeader from "../Header/AvailibilityPublicHeader";
import SaveTimeModal from "../Modals/SaveTimeModal";
import AvilibilityOptions from "data/Prod/AvailibilityDaysOptions.json";
import ScheduleWarningModal from "../Modals/ScheduleWarningModal";
import SaveAgendaModal from "../Modals/SaveAgendaModal";
import {
  appUserHeaderLinks,
  appUserProfileLink,
} from "helper/AppUserHelper/AppUserHelper";
import { useTranslation } from "react-i18next";
import { getPublicIP } from "helper/AuthHelper/AuthHelper";

const AppUserAvailabilityPublic = () => {
  const params = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const commonHeaderObject = appUserHeaderLinks(params.id, t);

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("App User"), link: appUserProfileLink },
    { title: t("Availability") },
  ];

  // ---- access control ----
  const [accessChecked, setAccessChecked] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  const isAdmin = ["ADMIN", "SUPER_ADMIN"].includes(
    userInfo?.role?.slug || ""
  );
  const isOwner = userInfo?._id?.toString() === params.id?.toString();

  const checkAccess = async () => {
    if (isAdmin || isOwner) {
      setHasAccess(true);
      setAccessChecked(true);
      return;
    }

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CALENDAR_FOLLOWERS +
        `/${params.id}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const isFollower = response.data.some(
          (f) => f._id?.toString() === userInfo?._id?.toString()
        );
        setHasAccess(isFollower);
      } else {
        setHasAccess(false);
      }
    } catch (error) {
      console.log(error.message);
      setHasAccess(false);
    }

    setAccessChecked(true);
  };
  // ------------------------

  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");

  const [taskDependOnCalender, setTaskDependOnCalender] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [avalibilityDays, setAvalibilityDays] = useState([]);

  const [selectedDayId, setselectedDayId] = useState(null);

  const [scheduleStartDate, setScheduleStartDate] = useState("");
  const [scheduleEndDate, setScheduleEndDate] = useState("");

  const [isDateSpecific, setIsDateSpecific] = useState(false);

  const [agendaListBySpecificDates, setAgendaListBySpecificDates] = useState(
    []
  );

  const [selectedCalendarAgendaDate, setSelectedCalendarAgendaDate] =
    useState("");
  const [selectedAgendaId, setSelectedAgendaId] = useState(null);

  const [calenderAgendaDates, setCalenderAgendaDates] = useState([]);

  const [isSaving, setIsSaving] = useState(false);

  //out of field requirements
  const [telephone, setTelephone] = useState("");
  const [position, setPosition] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [website, setWebsite] = useState("");
  const [rate, setRate] = useState("");
  const [address, setAddress] = useState("");

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  /* hooks for validation */
  const [validation, setValidation] = useState({
    startDateWarning: false,
    endDateWarning: false,
    dateDiffWarning: false,
    noAvailabilityWarning: false,
  });

  //* checking validation
  const validationHandler = () => {
    let isValid = true;
    const newValidation = {
      startDateWarning: false,
      endDateWarning: false,
      dateDiffWarning: false,
      noAvailabilityWarning: false,
    };

    if (scheduleStartDate == "") {
      newValidation.startDateWarning = true;
      isValid = false;
    }

    if (scheduleEndDate == "") {
      newValidation.endDateWarning = true;
      isValid = false;
    }

    if (scheduleStartDate !== "" && scheduleEndDate !== "") {
      if (scheduleStartDate > scheduleEndDate) {
        newValidation.dateDiffWarning = true;
        isValid = false;
      }
    }

    const checkBoxes = document.querySelectorAll('input[name="daycheckbox"]');
    const checkedBoxes = Array.from(checkBoxes).filter((cb) => cb.checked);
    const daysToCheck =
      checkedBoxes.length === 0
        ? avalibilityDays
        : avalibilityDays.filter((day) =>
            checkedBoxes.some((cb) => cb.value === day._id)
          );
    const hasAtLeastOneRecord = daysToCheck.some(
      (day) => day.timeavailibilityids.length > 0
    );
    if (!hasAtLeastOneRecord) {
      newValidation.noAvailabilityWarning = true;
      isValid = false;
    }

    setValidation(newValidation);
    return isValid;
  };

  //* function for get user details
  const getAppUserDetails = async () => {
    const userPublicIp = await getPublicIP();

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${params.id}` +
        ``;

      const response = await getData(requestUrl);

      if (response.status && response.data) {
        const data = response.data;

        setName(data.name || "");
        setSurName(data.surname || "");

        setTelephone(data.phone ?? "");
        setPosition(data.position ?? "");
        setAddress(data.address || "");
        setWebsite(data.website || "");
        setRate(data.costperhour || "");
        setstateName(data.state || "");
        setcityName(data.city || "");
        setcountry(data.country || "");
        setzipcode(data.zipcode || "");

        setTaskDependOnCalender(data.assigntaskwithcalender || false);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //create new availibility week
  const createWeekAvailibilityHandler = async () => {
    const userPublicIp = await getPublicIP();

    try {
      let availibilityData = {
        avilibilitydays: AvilibilityOptions,
        useraccount: params.id,
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_ADD_NEW_DAYS_AVAILIBILITY +
        `?userip=${userPublicIp}`;

      const response = await postData(requestUrl, availibilityData);

      if (response.status) {
        getAllWeekAvailibilitySettings();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get all availibility settings
  const getAllWeekAvailibilitySettings = async () => {
    const userPublicIp = await getPublicIP();

    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_DAYS_AVAILIBILITY +
        `?useraccount=${params.id}&userip=${userPublicIp}`;

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        if (response.data.length === 0) {
          createWeekAvailibilityHandler();
        } else {
          setAvalibilityDays(response.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //clear Time FromDay week settings
  const clearTimeFromDayHandler = async () => {
    const userPublicIp = await getPublicIP();

    const checkBoxes = document.querySelectorAll('input[name="daycheckbox"]');

    for (let checkBox of checkBoxes) {
      if (checkBox.checked) {
        const value = checkBox.value;

        const dataTimeIds = JSON.parse(checkBox.getAttribute("data-timeids"));

        if (dataTimeIds.length > 0) {
          for (let dataTimeId of dataTimeIds) {
            if (dataTimeId._id) {
              try {
                let requestUrl =
                  url.API_BASE_URL +
                  url.API_DELETE_TIME_AVAILIBILITY +
                  `/${dataTimeId._id}?profileuserid=${params.id}&userip=${userPublicIp}`;

                await deleteData(requestUrl);
              } catch (error) {
                console.log(error.message);
              }
            }
          }
          checkBox.checked = false;
        }
      }
    }
    getAllWeekAvailibilitySettings();
  };

  //add settings to schedule
  const addToScheduleHandler = async () => {
    const userPublicIp = await getPublicIP();

    if (validationHandler()) {
      try {
        setIsSaving(true);

        let agendaData = {
          startdate: scheduleStartDate,
          enddate: scheduleEndDate,
          useraccount: params.id,
          userip: userPublicIp,
        };

        let requestUrl =
          url.API_BASE_URL + url.API_SETTINGS_TO_AGENDA;

        const response = await postData(requestUrl, agendaData);

        setIsSaving(false);

        if (response.status) {
          setAlertMessage(t("Settings added to your calender successfully."));
          setMessageType("success");
          setShowAlert(true);
          setTimeout(() => {
            setScheduleStartDate("");
            setScheduleEndDate("");
            getAllAgenda();
          }, 1000);
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  //reset validation
  const resetValidation = () => {
    setValidation({
      startDateWarning: false,
      endDateWarning: false,
      dateDiffWarning: false,
      noAvailabilityWarning: false,
    });
  };

  // validate then open schedule warning modal
  const handleAddToCalendarClick = () => {
    if (validationHandler()) {
      let myModal = new bootstrap.Modal(
        document.getElementById("scheduleWarning")
      );
      myModal.show();
    }
  };

  //get all agenda date specific
  const getAllAgenda = async () => {
    const userPublicIp = await getPublicIP();

    try {
      let useraccountArr = [params.id];

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_AGENDA +
        `?useraccount=${useraccountArr}&userip=${userPublicIp}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setAgendaListBySpecificDates(
          response.data.filter((item) => item.datespecifichours)
        );
        setCalendarEventData(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Calendar ---------------------------------------------
  const localizer = momentLocalizer(moment);

  const setCalendarEventData = (agendaRecords) => {
    let filteredEventData = [];

    if (agendaRecords.length > 0) {
      for (let agenda of agendaRecords) {
        const agendaId = agenda._id;
        const agendaTitle = agenda.description;
        const startAgendaTime = agenda.date + "T" + agenda.starttime + ":00";
        const endAgendaTime = agenda.date + "T" + agenda.endtime + ":00";

        const event = {
          id: agendaId,
          title: agendaTitle,
          start: new Date(startAgendaTime),
          end: new Date(endAgendaTime),
          availability: agenda.availability,
        };

        filteredEventData.push(event);
      }
    }

    setCalenderAgendaDates(filteredEventData);
  };

  const eventStyleGetter = (event) => {
    const backgroundColor = event.availability ? "#05843e" : "#DF3429";
    return { style: { backgroundColor } };
  };

  const onSelectEvent = (event) => {
    setSelectedAgendaId(event.id);

    let myModal = new bootstrap.Modal(
      document.getElementById("saveAccountAgenda")
    );
    myModal.show();
  };

  const onSelectSlot = (event) => {
    const dateObj = new Date(event.start);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    setSelectedCalendarAgendaDate(formattedDate);

    let myModal = new bootstrap.Modal(
      document.getElementById("saveAccountAgenda")
    );
    myModal.show();
  };
  // ----------------------------------------------------

  useEffect(() => {
    if (params.id) {
      checkAccess();
    }
  }, [params.id]);

  useEffect(() => {
    if (hasAccess && params.id) {
      getAppUserDetails();
      getAllWeekAvailibilitySettings();
      getAllAgenda();
    }
  }, [hasAccess, params.id]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // ---- no privilege screen ----
  if (accessChecked && !hasAccess) {
    return (
      <div id="content_wrapper">
        <section className="expert-details-wrapper bg-white pb-5">
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Availability")}
            />
          )}
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            <BreadCrumb
              breadCrumbText={breadcrumbText}
              bottom={true}
              displayName={`${name} ${surName}`}
            />
            <div className="d-flex flex-column align-items-center justify-content-center py-5 my-5 text-center">
              <div className="mb-4 p-4 bg-light rounded-circle">
                <span className="material-symbols-outlined text-danger" style={{ fontSize: 64 }}>
                  lock
                </span>
              </div>
              <h3 className="fw-bold mb-2">{t("Access Restricted")}</h3>
              <p className="text-muted fs-md mb-0" style={{ maxWidth: 480 }}>
                {t(
                  "Sorry, you don't have the privilege to view this calendar. Please ask the admin or owner to add you as a manager."
                )}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  // ---- loading access check ----
  if (!accessChecked) {
    return (
      <div id="content_wrapper">
        <section className="expert-details-wrapper bg-white pb-5">
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Availability")}
            />
          )}
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            <div className="d-flex align-items-center justify-content-center py-5 my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div id="content_wrapper">
      <section className="expert-details-wrapper bg-white pb-5">

        <div className="container-fluid px-lg-5 pt-4 pt-md-0">
          {/* ---- bread crumb ------- */}
          <BreadCrumb
            breadCrumbText={breadcrumbText}
            bottom={true}
            displayName={`${name} ${surName}`}
          />

          {/* header */}
          <AvailibilityPublicHeader />

          {/* weekly hours settings */}
          <div className="tab-content" id="viewTabContent">
            <div
              className="tab-pane fade show active"
              id="list-view"
              role="tabpanel"
              aria-labelledby="list-view-tab"
              tabIndex="0"
            >
              <div className="px-3 px-lg-4 border border-gray-300 rounded-10 shadow-sm">
                <div className="row gx-lg-5">
                  <div className="col-lg-6 mb-4 py-3 py-lg-4 mb-lg-0 border-end">
                    {/* STEP 1: Weekly Hours Selection */}
                    <h3 className="fw-semibold mb-4">
                      Create weekly availability - Add to calendar
                    </h3>

                    <div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <p className=" mb-0 fw-semibold">
                          <span className="text-primary">STEP 1 </span> : {" "}
                          {t("Add weekly availability by selecting days and time slots")}
                        </p>
                        <Link
                          to="#"
                          className="d-flex align-items-center gap-1 fw-semibold text-danger text-decoration-none"
                          onClick={clearTimeFromDayHandler}
                        >
                          <span className="d-block material-symbols-outlined fs-lg">
                            delete
                          </span>
                          <span className="d-block">{t("Clear")}</span>
                        </Link>
                      </div>

                      {/* List of days availability */}
                      <ul className="d-flex flex-column gap-2 list-unstyled">
                        {avalibilityDays.map((dayData, index) => (
                          <li
                            className="d-flex align-items-center gap-3 bg-light p-3 rounded"
                            key={index}
                          >
                            <div className="form-check d-flex align-items-center gap-2 p-0 m-0">
                              <input
                                className="form-check-input border-2 border-gray-400 m-0 shadow-none"
                                type="checkbox"
                                id={dayData.slug}
                                name="daycheckbox"
                                value={dayData._id}
                                data-timeids={JSON.stringify(
                                  dayData.timeavailibilityids
                                )}
                              />
                              <label
                                className="form-check-label fw-semibold"
                                htmlFor={dayData.slug}
                              >
                                {dayData.dayname.substring(0, 3).toUpperCase()}
                              </label>
                            </div>

                            <div className="flex-fill">
                              {dayData.timeavailibilityids.length === 0 ? (
                                <p className="text-muted mb-0">
                                  {t("Unavailable")}
                                </p>
                              ) : (
                                <div className="d-flex flex-column gap-2">
                                  {dayData.timeavailibilityids.map(
                                    (timeData, index) => (
                                      <ul
                                        className="times lh-1 d-flex align-items-center gap-2 flex-wrap list-unstyled mb-0"
                                        key={index}
                                      >
                                        <li className="px-2 py-1 text-gray border border-gray-300 rounded-pill">
                                          {timeData.starttime}
                                        </li>
                                        <li className="text-gray">-</li>
                                        <li className="px-2 py-1 text-gray border border-gray-300 rounded-pill">
                                          {timeData.endtime}
                                        </li>
                                        <li
                                          className={
                                            timeData?.location === ""
                                              ? "d-none"
                                              : "text-gray"
                                          }
                                        >
                                          -
                                        </li>
                                        <li
                                          className={
                                            timeData?.location === ""
                                              ? "d-none"
                                              : "px-2 py-1 text-gray border border-gray-300 rounded-pill"
                                          }
                                        >
                                          {timeData?.location}
                                        </li>
                                        <li
                                          className={
                                            timeData?.companyname === ""
                                              ? "d-none"
                                              : "text-gray"
                                          }
                                        >
                                          -
                                        </li>
                                        <li
                                          className={
                                            timeData?.companyname === ""
                                              ? "d-none"
                                              : "px-2 py-1 text-gray border border-gray-300 rounded-pill"
                                          }
                                        >
                                          {timeData?.companyname}
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </div>
                              )}
                            </div>

                            <Link
                              to="#"
                              className="text-muted ms-auto"
                              data-bs-toggle="modal"
                              data-bs-target="#editTimeForDay"
                              onClick={() => setselectedDayId(dayData._id)}
                            >
                              <span className="d-block material-symbols-outlined">
                                {dayData.timeavailibilityids.length === 0
                                  ? "add"
                                  : "edit"}
                              </span>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* STEP 2: Date Range Selection */}
                    <div className="mb-4">
                      <p className="fw-semibold mb-3">
                        <span className=" text-primary">STEP 2</span> &nbsp;:&nbsp; Select Date Range to create
                        availability
                      </p>
                      <form
                        onSubmit={(e) => e.preventDefault()}
                        className="d-flex align-items-center gap-3"
                      >
                        <div className="position-relative flex-fill">
                          <input
                            type="date"
                            className="form-control fs-sm shadow-none"
                            value={scheduleStartDate}
                            onChange={(e) => {
                              setScheduleStartDate(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                startDateWarning: false,
                                dateDiffWarning: false,
                              }));
                            }}
                          />
                        </div>

                        <span className="fw-semibold">To</span>

                        <div className="position-relative flex-fill">
                          <input
                            type="date"
                            className="form-control fs-sm shadow-none"
                            value={scheduleEndDate}
                            onChange={(e) => {
                              setScheduleEndDate(e.target.value);
                              setValidation((prevState) => ({
                                ...prevState,
                                endDateWarning: false,
                                dateDiffWarning: false,
                              }));
                            }}
                          />
                        </div>
                      </form>

                      {/* Validation Messages */}
                      <div className="d-flex flex-column gap-1 mt-2">
                        {validation.startDateWarning && (
                          <div className="error-message">
                            <p className="d-flex align-items-center gap-1 text-danger mb-0">
                              <span className="material-symbols-outlined">warning</span>
                              <span>{t("Please enter start date!")}</span>
                            </p>
                          </div>
                        )}
                        {validation.endDateWarning && (
                          <div className="error-message">
                            <p className="d-flex align-items-center gap-1 text-danger mb-0">
                              <span className="material-symbols-outlined">warning</span>
                              <span>{t("Please enter end date!")}</span>
                            </p>
                          </div>
                        )}
                        {validation.dateDiffWarning && (
                          <div className="error-message">
                            <p className="d-flex align-items-center gap-1 text-danger mb-0">
                              <span className="material-symbols-outlined">warning</span>
                              <span>
                                {t("End date should not be less then start date!")}
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#scheduleWarning"
                        onClick={resetValidation}
                        disabled={isSaving}
                        style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                      >
                        {isSaving && (
                          <div
                            className="mx-2 spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}{" "}
                        {t("Add the selected time slots to Calendar")}
                      </button>
                    </div>
                  </div>

                  {/* specific date  */}
                  <div className="col-lg-6 py-3 py-lg-4">
                    <h5 className="fs-lg fw-semibold mb-0">
                      {t("Date-Specific Hours")}
                    </h5>
                    <p className="fs-sm text-gray">
                      {t(
                        "Override your availability for specific dates when your hours differ from your regular weekly hours."
                      )}
                    </p>
                    <ul className="d-flex flex-column gap-1 my-3">
                      {agendaListBySpecificDates.map((dateData, index) => {
                        return (
                          <li
                            className="d-flex align-items-start gap-3 body-bg p-3 rounded-10"
                            key={index}
                          >
                            <div className="form-check d-flex align-items-center gap-2 p-0 m-0 cursor-pointer">
                              <span className="d-block material-symbols-outlined icon-lg">
                                calendar_month
                              </span>
                              <label
                                className="form-check-label fw-semibold cursor-pointer"
                                htmlFor="datelabel"
                              >
                                {dateData.agendadate}
                              </label>
                            </div>
                            <div className="hours-container d-flex flex-column gap-2 flex-fill">
                              <ul className="times lh-1 d-flex align-items-center gap-2 flex-wrap">
                                <li className="px-2 py-1 text-gray border border-gray-300 rounded-90">
                                  {dateData.starttime}
                                </li>
                                <li className="text-gray">-</li>
                                <li className="px-2 py-1 text-gray border border-gray-300 rounded-90">
                                  {dateData.endtime}
                                </li>
                                <li
                                  className={
                                    dateData?.location === ""
                                      ? "d-none"
                                      : "text-gray"
                                  }
                                >
                                  -
                                </li>
                                <li
                                  className={
                                    dateData?.location === ""
                                      ? "d-none"
                                      : "px-2 py-1 text-gray border border-gray-300 rounded-90"
                                  }
                                >
                                  {dateData?.location}
                                </li>
                              </ul>
                            </div>
                            <Link
                              to="#"
                              className="text-gray ms-auto"
                              data-bs-toggle="modal"
                              data-bs-target="#saveAccountAgenda"
                              onClick={() => {
                                setSelectedAgendaId(dateData._id);
                                setIsDateSpecific(true);
                              }}
                            >
                              <span className="d-block material-symbols-outlined">
                                edit
                              </span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                    <Link
                      to="#"
                      className="btn btn-outline-primary d-inline-flex align-items-center gap-1"
                      data-bs-toggle="modal"
                      data-bs-target="#saveAccountAgenda"
                      onClick={() => {
                        setIsDateSpecific(true);
                      }}
                    >
                      <span className="d-block material-symbols-outlined fs-lg">
                        add
                      </span>
                      <span className="d-block">
                        {t("Add date-specific hours")}
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* calender/agenda view */}
            <div
              className="tab-pane fade"
              id="calendar-view"
              role="tabpanel"
              aria-labelledby="calendar-view-tab"
              tabIndex="0"
            >
              <div style={{ height: 500 }}>
                <Calendar
                  localizer={localizer}
                  events={calenderAgendaDates}
                  startAccessor="start"
                  endAccessor="end"
                  onSelectEvent={onSelectEvent}
                  onSelectSlot={onSelectSlot}
                  selectable
                  style={{ flex: 1 }}
                  eventPropGetter={eventStyleGetter}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* modals */}
      <SaveTimeModal
        afterModalClose={getAllWeekAvailibilitySettings}
        selectedDayId={selectedDayId}
        setselectedDayId={setselectedDayId}
      />

      <ScheduleWarningModal onConfirm={addToScheduleHandler} />

      <SaveAgendaModal
        onModalClose={getAllAgenda}
        selectedAgendaId={selectedAgendaId}
        setSelectedAgendaId={setSelectedAgendaId}
        setIsDateSpecific={setIsDateSpecific}
        isDateSpecific={isDateSpecific}
        selectedCalendarAgendaDate={selectedCalendarAgendaDate}
        setSelectedCalendarAgendaDate={setSelectedCalendarAgendaDate}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default AppUserAvailabilityPublic;
